import { datadogLogs } from '@datadog/browser-logs'
import { datadogAddContext } from './ddLibs.js'

const env = window.homair.isStaging ? 'staging' : window.homair.isDev ? 'dev' : 'production'

window.datadogLogs = datadogLogs

window.initDatadogLogger = function () {
  window.datadogLogs.init({
    clientToken: 'pubcb6572d65e3f50119b0b383d60e410b7',
    service: 'tunnel',
    site: 'datadoghq.eu',
    env,
    forwardErrorsToLogs: false,
    forwardConsoleLogs: ['error'],
    sessionSampleRate: 100, // 100% users
    beforeSend: (log) => {
      // don't log network failures and cancellations
      if (log.http && log.http.status_code === 0) {
        return false
      }

      // Ignore some errors.
      if (log.message && log.message.indexOf('ResizeObserver loop limit exceeded') >= 0) {
        return false
      }
    },
  })

  window.datadogLogs.setGlobalContextProperty('loggerType', 'datadogLogs')

  datadogAddContext(window.datadogLogs)
}

window.initDatadogLogger()
